
function validateSubject(value) {
    if (value == '' || !value.trim()) {
        this.errors.subject = {
            msg: 'Subject is required',
            success: true
        }
    } else {
        this.errors.subject = {
            msg: '',
            success: false
        }
    }
}
function validateBody(value) {
    if (value == '' || !value.trim()) {
        this.errors.body = {
            msg: 'Body is required',
            success: true
        }
    } else {
        this.errors.body = {
            msg: '',
            success: false
        }
    }
}

function validatePerks(perks, prop) {
    let val = 0;
    perks.forEach(perk => {
        if (perk.show) {
            if (!perk.category || perk.category == '') {
                val = 1
            }
            else {
                if (!perk.disable) {
                    // if(!perk.description || perk.description == ''){
                    //     val = 2
                    // }
                    // else
                    // if(!perk.estimated_value){
                    //     val = 3
                    // }
                    // else
                    if (!perk.key_date) {
                        val = 4
                    }
                    else {
                        if (!perk.date_type) {
                            val = 5
                        }
                        else {
                            if (perk.key_date == 'custom_date' && perk.custom_dates.length == 0) {
                                val = 6
                            }
                            else {
                                if (perk.key_date == 'custom_date' && perk.custom_dates.length > 0) {
                                    let emptyDates = perk.custom_dates.filter(cd => cd == '');
                                    if (emptyDates && emptyDates.length > 0)
                                        val = 7
                                }
                            }
                        }
                    }

                    if (!perk.call_to_action || perk.call_to_action == "") {
                        val = 8
                    }
                    else {
                        if (perk.call_to_action == 'track_usage') {
                            if (!perk.track_usage.option_value) {
                                val = 9
                            }
                            else {
                                if (perk.track_usage.option_value == 'multiple_use_limited') {
                                    if (perk.track_usage.multiple_use_limit < 0) { val = 10 }
                                }
                            }
                        }
                        if (perk.call_to_action == 'mark_as_enrolled') {
                            if (!perk.mark_as_enrolled.option_value) {
                                val = 11
                            }
                            else {
                                // if(perk.mark_as_enrolled.option_value=='enrollment_with_expiration'){

                                // }
                            }
                        }
                        if (perk.call_to_action == 'track_earned_tiers') {
                            if (!perk.track_earned_tiers.option_value) {
                                val = 13
                            }
                            else {
                                if (perk.track_earned_tiers.input_text == "") {
                                    val = 14
                                }
                            }
                        }
                    }
                }
            }
        }
    })

    switch (val) {
        case 1:
            this.errors[prop] = {
                msg: 'Category is required',
                success: true
            }
            break;
        case 2:
            this.errors[prop] = {
                msg: 'Description is required',
                success: true
            }
            break;
        case 3:
            this.errors[prop] = {
                msg: 'Estimated value is required',
                success: true
            }
            break;
        case 4:
            this.errors[prop] = {
                msg: 'Key date is required',
                success: true
            }
            break;
        case 5:
            this.errors[prop] = {
                msg: 'Date type is required',
                success: true
            }
            break;
        case 6:
            this.errors[prop] = {
                msg: 'Custom dates are required',
                success: true
            }
            break;
        case 7:
            this.errors[prop] = {
                msg: 'Please enter all custom dates',
                success: true
            }
            break;
        case 8:
            this.errors[prop] = {
                msg: 'Call to action is required',
                success: true
            }
            break;
        case 9:
            this.errors[prop] = {
                msg: 'Please select an option to Track usage',
                success: true
            }
            break;
        case 10:
            this.errors[prop] = {
                msg: 'Please enter number of limit',
                success: true
            }
            break;
        case 11:
            this.errors[prop] = {
                msg: 'Please select an option for Mark as enrolled',
                success: true
            }
            break;
        case 13:
            this.errors[prop] = {
                msg: 'Please select an option for Track earned tier',
                success: true
            }
            break;
        case 14:
            this.errors[prop] = {
                msg: 'Please input text to describe the earned tier',
                success: true
            }
            break;

        default:
            this.errors[prop] = {
                msg: '',
                success: false
            }
            break;
    }
}

function validatePointsNames(points, prop) {
    let hasErr = false;
    points.forEach(val => {
        if (val.points_category == "") {
            hasErr = true;
        }
    })
    if (hasErr) {
        this.errors[prop] = {
            msg: 'Points category name is required',
            success: true
        }
    }
    else {
        this.errors[prop] = {
            msg: '',
            success: false
        }
    }
}



function validatePoints(points, prop) {
    let flag = false;
    let flag2 = false;
    let flag3 = false;
    points.forEach(val => {
        if (val.points_category == "") {
            flag2 = true;
        }
        if (val.multiplier <= 0) {
            flag = true;
        }
        if (!val.percentage) {
            flag3 = true;
        }
    })
    if (flag2) {
        this.errors[prop] = {
            msg: 'Points category name is required',
            success: true
        }
    }
    else
        if (flag3) {
            this.errors[prop] = {
                msg: 'Points category percentage is required',
                success: true
            }
        }
        else if (flag) {
            this.errors[prop] = {
                msg: 'Points category multiplier should be greater than 0',
                success: true
            }
        } else {
            this.errors[prop] = {
                msg: '',
                success: false
            }
        }
}

function validateGroupPoints(points, prop) {
    let flag = false;
    let flag2 = false;
    let flag3 = false;

    points.forEach(val => {
        if (val.points_category == "") {
            flag2 = true;
        }
        if (val.multiplier <= 0) {
            flag = true;
        }
        if (!val.percentage) {
            flag3 = true;
        }
        if (flag2 == false && flag == false && flag3 == false) {
            val.groupCategories.forEach(data => {
                if (data.points_category == "") {
                    flag2 = true;
                }
                if (data.multiplier <= 0) {
                    flag = true;
                }
                if (!data.percentage) {
                    flag3 = true;
                }
            })
        }
    })
    if (flag2) {
        this.errors[prop] = {
            msg: 'Points category name is required',
            success: true
        }
    }
    else
        if (flag3) {
            this.errors[prop] = {
                msg: 'Points category percentage is required',
                success: true
            }
        }
        else if (flag) {
            this.errors[prop] = {
                msg: 'Points category multiplier should be greater than 0',
                success: true
            }
        } else {
            this.errors[prop] = {
                msg: '',
                success: false
            }
        }
}
function validateFeeCategory(credits) {
    if (credits.length > 0) {
        let val = 0;
        credits.forEach(credit => {
            if (credit.credit_title == '') {
                val = 1;
            }
            else
                if (credit.amount == 0 || credit.amount == '') {
                    val = 2;
                }
                else
                    if (!credit.per_use_amount || credit.per_use_amount == 0 || credit.per_use_amount == '') {
                        val = 3;
                    }
                    else
                        if (!credit.expiration_date_type || credit.expiration_date_type == '') {
                            val = 4;
                        }
                        else
                            if (credit.expiration_date_type == 'custom_date' && credit.custom_dates.length == 0) {
                                val = 5;
                            }
                            else
                                if (credit.expiration_date_type == 'custom_date' && credit.custom_dates.length > 0) {
                                    let emptyDates = credit.custom_dates.filter(cd => cd == '');
                                    if (emptyDates && emptyDates.length > 0)
                                        val = 6;
                                }
                                else
                                    if (!credit.na_cutoff && !credit.cutoff_date) {
                                        val = 7;
                                    }
        });

        switch (val) {
            case 1:
                this.errors.feeCategory = {
                    msg: 'Credit title is required',
                    success: true
                }
                break;
            case 2:
                this.errors.feeCategory = {
                    msg: 'Credit amount is required',
                    success: true
                }
                break;
            case 3:
                this.errors.feeCategory = {
                    msg: 'Credit per use amount is required',
                    success: true
                }
                break;
            case 4:
                this.errors.feeCategory = {
                    msg: 'Credit expiration date type is required',
                    success: true
                }
                break;
            case 5:
                this.errors.feeCategory = {
                    msg: 'Custom dates are required',
                    success: true
                }
                break;
            case 6:
                this.errors.feeCategory = {
                    msg: 'Please enter all custom dates',
                    success: true
                }
                break;
            case 7:
                this.errors.feeCategory = {
                    msg: 'Please select cutoff date',
                    success: true
                }
                break;
            default:
                this.errors.feeCategory = {
                    msg: '',
                    success: false
                }
                break;
        }
    } else {
        this.errors.feeCategory = {
            msg: '',
            success: false
        }
    }
}
function validateRules(value, flag) {
    if (value == 0 && flag == 'Yes') {
        this.errors.rules = {
            msg: 'Rules are required',
            success: true
        }
    } else {
        this.errors.rules = {
            msg: '',
            success: false
        }
    }
}
function validateNumeric(event, flag) {
    let { keyCode, shiftKey, target } = event;
    if (flag && (keyCode === 110 || keyCode === 190 || keyCode === 46)) {
        return false;
    }
    else {
        if (keyCode !== 69 && keyCode !== 187 && keyCode !== 189 && keyCode !== 190 && keyCode !== 107 && keyCode !== 109 && keyCode !== 110 && !shiftKey && target.value < 100000 || keyCode === 8 || (shiftKey && (keyCode === 9 || keyCode === 16)) || keyCode === 9) {
            return false;
        }
        else {
            console.log("prevent")
            event.preventDefault();
        }
    }
}
function validateAlphaNumeric(event) {
    let { keyCode } = event;
    if ((keyCode >= 48 && keyCode <= 57) || (keyCode == 8) || (keyCode == 32) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || (keyCode == 9) || (keyCode == 46) || ((keyCode >= 33) && (keyCode <= 40)) || (keyCode == 12) || (keyCode == 45)) {
        return false;
    }
    else {
        event.preventDefault();
    }
}
function validateAlpha(event) {
    let { keyCode } = event;
    if (keyCode !== 46) {
        if ((keyCode == 8) || (keyCode == 32) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || (keyCode == 9) || (keyCode == 46)) {
            return false;
        }
    }
    event.preventDefault();
}

function validateEmail(value) {
    if (value == '' || !value.trim()) {
        this.errors.email = {
            msg: 'Email is required',
            success: true
        }
    } else {
        this.errors.email = {
            msg: '',
            success: false
        }
    }
}

function validatePassword(value) {
    if (value == '' || !value.trim()) {
        this.errors.password = {
            msg: 'Password is required',
            success: true
        }
    } else {
        this.errors.password = {
            msg: '',
            success: false
        }
    }
}


function onLoginSubmit() {
    let flag = true;
    if (this.email == '') {
        this.errors.email = {
            msg: 'Email is required',
            success: true
        }
        flag = false;
    }
    if (this.password == '') {
        this.errors.password = {
            msg: 'Password is required',
            success: true
        }
        flag = false;
    }
    return flag;
}

function validateIssuerName(value) {
    if (value == '' || !value.trim()) {
        this.errors.issuerName = {
            msg: 'Issuer Name is required',
            success: true
        }
    } else {
        this.errors.issuerName = {
            msg: '',
            success: false
        }
    }
}
function validateLinkUrl(value) {
    if (value == '' || !value.trim()) {
        this.errors.url = {
            msg: 'Link Url is required',
            success: true
        }
    } else {
        this.errors.url = {
            msg: '',
            success: false
        }
    }
}
function onSubmitIssuer(check) {
    let flag = true;
    if (check == 'add') {
        if (this.issuer.name == '') {
            this.errors.issuerName = {
                msg: 'Issuer Name is required',
                success: true
            }
            flag = false;
        }
    }
    else if (check == 'update') {
        if (this.editIssuerInfo.name == '') {
            this.errors.issuerName = {
                msg: 'Issuer Name is required',
                success: true
            }
            flag = false;
        }
    }
    return flag;
}

function validateUpgradeCard(value) {
    if (value == '' || !value.trim()) {
        this.errors.upgradeCard = {
            msg: 'Upgrade Card is required',
            success: true
        }
    } else {
        this.errors.upgradeCard = {
            msg: '',
            success: false
        }
    }
}

function validateUploadPhoto(value) {
    if (value == '') {
        this.errors.photo = {
            msg: 'Upload Photo is required',
            success: true
        }
    } else {
        this.errors.photo = {
            msg: '',
            success: false
        }
    }
}

function validateCardName(value) {
    if (value == '' || !value.trim()) {
        this.errors.cardName = {
            msg: 'Card Name is required',
            success: true
        }
    } else {
        this.errors.cardName = {
            msg: '',
            success: false
        }
    }
}

function validateExpirationDate(value) {
    if (value == '' || !value.trim()) {
        this.errors.date = {
            msg: 'Expiration Date is required',
            success: true
        }
    } else {
        this.errors.date = {
            msg: '',
            success: false
        }
    }
}

function validateEmoji(value) {
    if (value == '' || !value.trim()) {
        this.errors.emoji = {
            msg: 'Emoji is required',
            success: true
        }
    } else {
        this.errors.emoji = {
            msg: '',
            success: false
        }
    }
}

function validateDisclosure(value) {
    if (value == '' || !value.trim()) {
        this.errors.disclosure = {
            msg: 'Additional Disclosure is required',
            success: true
        }
    } else {
        this.errors.disclosure = {
            msg: '',
            success: false
        }
    }
}

function validateRatesFees(value, rates) {
    if (value != '' && value == 'amex' && (rates == '' || !rates.trim())) {
        this.errors.rates_fees = {
            msg: 'Rates and fees is required',
            success: true
        }
    } else {
        this.errors.rates_fees = {
            msg: '',
            success: false
        }
    }
}
function validateBonusType(value) {
    //console.log(value);
    if (value == '' || !value.trim()) {
        this.errors.bonusType = {
            msg: 'Bonus Type is required',
            success: true
        }
    } else if (value == "select_bonus_type") {
        this.errors.bonusType = {
            msg: 'Bonus Type is required',
            success: true
        }
    }
    else {
        this.errors.bonusType = {
            msg: '',
            success: false
        }
    }
}

function validateBonus(value) {
    //console.log("gi", value, value[value.length - 1])
    if (value == '' || !value.trim()) {
        this.errors.bonus = {
            msg: 'Bonus Amount is required',
            success: true
        }
    } else if (!(value[value.length - 1] >= 48) && !(value[value.length - 1] <= 57)) {
        this.errors.bonus = {
            msg: 'Only Numberic Characters Allowed',
            success: true
        }
    } else {
        this.errors.bonus = {
            msg: '',
            success: false
        }
    }
}

function validateProductChange(value) {
    if (value == '' || !value.trim()) {
        this.errors.productChange = {
            msg: 'Product Change is required',
            success: true
        }
    } else {
        this.errors.productChange = {
            msg: '',
            success: false
        }
    }
}

function validateDowngradeCard(value) {
    if (value == '' || !value.trim()) {
        this.errors.downgradeCard = {
            msg: 'Downgrade Card is required',
            success: true
        }
    } else {
        this.errors.downgradeCard = {
            msg: '',
            success: false
        }
    }
}

function validateAnnualFee(value) {
    if (value === '') {
        this.errors.annualFee = {
            msg: 'Annual Fee is required',
            success: true
        }
    } else {
        this.errors.annualFee = {
            msg: '',
            success: false
        }
    }
}

function validateFeeDescription(value) {
    if (value == '' || !value.trim()) {
        this.errors.effectiveDescription = {
            msg: 'Effective Fee is required',
            success: true
        }
    } else {
        this.errors.effectiveDescription = {
            msg: '',
            success: false
        }
    }
}

function validatePointDescription(value) {
    if (value == '' || !value.trim()) {
        this.errors.pointDescription = {
            msg: 'Point Description is required',
            success: true
        }
    } else {
        this.errors.pointDescription = {
            msg: '',
            success: false
        }
    }
}

function validateReply(value) {
    if (value == '' || !value.trim()) {
        this.errors.reply = {
            msg: 'Reply Message is required',
            success: true
        }
    } else {
        this.errors.reply = {
            msg: '',
            success: false
        }
    }
}

function validateFirstName(value) {
    if (value == '' || !value.trim()) {
        this.errors.firstName = {
            msg: 'First Name is required',
            success: true
        }
    }
    else if (value.length < 2) {
        this.errors.firstName = {
            msg: 'First Name should contain atleast two characters',
            success: true
        }
    }
    else {
        this.errors.firstName = {
            msg: '',
            success: false
        }
    }
}

function validateLastName(value) {
    if (value == '' || !value.trim()) {
        this.errors.lastName = {
            msg: 'Last Name is required',
            success: true
        }
    }
    else if (value.length < 2) {
        this.errors.lastName = {
            msg: 'Last Name should contain atleast two characters',
            success: true
        }
    }
    else {
        this.errors.lastName = {
            msg: '',
            success: false
        }
    }
}

function validateConfirmPassword(value) {
    if (value == '' || !value.trim()) {
        this.errors.password2 = {
            msg: 'Confirm Password is required',
            success: true
        }
    } else {
        if (this.newAdmin.password != this.newAdmin.confirmP) {
            this.errors.password2 = {
                msg: 'Confrim Password is not matched',
                success: true
            }
        }
    }
}

function onAddAdmin(ref, check) {
    let flag = true;
    if (check == 'add') {
        if (ref.newAdmin.fname == '') {
            ref.errors.firstName = {
                msg: 'First Name is required',
                success: true
            }
            flag = false;
        }
        if (ref.newAdmin.lname == '') {
            ref.errors.lastName = {
                msg: 'Last Name is required',
                success: true
            }
            flag = false;
        }
        if (ref.newAdmin.email == '') {
            ref.errors.email = {
                msg: 'Email is required',
                success: true
            }
            flag = false;
        }
        if (ref.newAdmin.password == '') {
            ref.errors.password = {
                msg: 'Password is required',
                success: true
            }
            flag = false;
        }
        else {
            if (ref.newAdmin.password != ref.newAdmin.confirmP) {
                ref.errors.password2 = {
                    msg: 'Confrim Password is not matched',
                    success: true
                }
                flag = false;
            }
            else {
                ref.errors.password2 = {
                    msg: '',
                    success: false
                }
            }
        }
        if (ref.newAdmin.confirmP == '') {
            ref.errors.password2 = {
                msg: 'Confirm Password is required',
                success: true
            }
            flag = false;
        }
        if (ref.newAdmin.photo == '') {
            ref.errors.photo = {
                msg: 'Photo is required',
                success: true
            }
            flag = false;
        }
    }
    else {
        if (ref.updateAdmin.fname == '') {
            ref.errors.firstName = {
                msg: 'First Name is required',
                success: true
            }
            flag = false;
        }
        if (ref.updateAdmin.lname == '') {
            ref.errors.lastName = {
                msg: 'Last Name is required',
                success: true
            }
            flag = false;
        }
        if (ref.updateAdmin.email == '') {
            ref.errors.email = {
                msg: 'Email is required',
                success: true
            }
            flag = false;
        }
        if (ref.updateAdmin.password != ref.updateAdmin.confirmP) {
            ref.errors.password2 = {
                msg: 'Confrim Password is not matched',
                success: true
            }
            flag = false;
        }
        else {
            ref.errors.password2 = {
                msg: '',
                success: false
            }
        }
    }
    return flag;
}

function onAccountSettings() {
    let flag = true;
    if (this.updateAdmin.fname == '') {
        this.errors.firstName = {
            msg: 'First Name is required',
            success: true
        }
        flag = false;
    }
    if (this.updateAdmin.lname == '') {
        this.errors.lastName = {
            msg: 'Last Name is required',
            success: true
        }
        flag = false;
    }
    if (this.updateAdmin.email == '') {
        this.errors.email = {
            msg: 'Email is required',
            success: true
        }
        flag = false;
    }
    if (this.updateAdmin.password != this.updateAdmin.confirmP) {
        this.errors.password2 = {
            msg: 'Confrim Password is not matched',
            success: true
        }
        flag = false;
    }
    else {
        this.errors.password2 = {
            msg: '',
            success: false
        }
    }
    return flag;
}

function validateRuleEffectiveDate(value, index) {
    if (value == '') {
        this.errors.ruleDate[index] = {
            msg: 'Effective Date is required',
            success: true
        }
    } else {
        this.errors.ruleDate[index] = {
            msg: '',
            success: false
        }
    }
}

function validateHeadline(headline) {
    if (headline.trim() == "") {
        this.errors.headline = {
            msg: "Headline is required",
            success: true,
        };
        return false;
    } else {
        this.errors.headline = {
            msg: "",
            success: false,
        };
        return true;
    }
}
function validatePrimaryHashtag(primaryHashtag) {
    if (primaryHashtag.trim() == "") {
        this.errors.primaryHashtag = {
            msg: "Primary hashtag is required",
            success: true,
        };
        return false;
    } else {
        var letters = /^[a-z0-9]+$/i;
        //var regEx = /^[0-9a-zA-Z]+$/;
        if (primaryHashtag.toString().match(letters)) {
        }
        else {
            this.errors.primaryHashtag = {
                msg: "Primary hashtag must be alphanumeric",
                success: true,
            };
            return false
        }
        this.errors.primaryHashtag = {
            msg: "",
            success: false,
        };
        return true;
    }
}
function validatePromoCategory(promoCategoryList, point_categoriesList) {
    if (promoCategoryList.length > 0) {
        if (promoCategoryList[0].trim() == "") {
            this.errors.promoCategoryList = {
                msg: "Promo Category is required",
                success: true,
            };
            return false;
        } else {
            this.errors.promoCategoryList = {
                msg: "",
                success: false,
            };
            return true;
        }
    } else {
        this.errors.promoCategoryList = {
            msg: "Promo Category is required",
            success: true,
        };
        return false;
    }
}

function validateBonusCategory(bonusCategoryId, point_categoriesList) {
    if (point_categoriesList.length > 0) {
        if (bonusCategoryId.trim() == "") {
            this.errors.bonusCategoryId = {
                msg: "Bonus Category is required",
                success: true,
            };
            return false;
        } else {
            this.errors.bonusCategoryId = {
                msg: "",
                success: false,
            };
            return true;
        }
    } else {
        return true;
    }
}

function validateTargetedStatus(targetedSatus) {
    if (targetedSatus.trim() == "") {
        this.errors.targetedSatus = {
            msg: "Targeted Status is required",
            success: true,
        };
        return false;
    } else {
        this.errors.targetedSatus = {
            msg: "",
            success: false,
        };
        return true;
    }
}
function validateTargetedOffers(points, prop) {
    let flag = false;
    let flag2 = false;
    let flag3 = false;
    let flag4 = false;
    let flag5 = false;
    let flag6 = false;
    points.forEach(data => {
        if (data.categories && data.categories.length > 0) {
            data.categories.forEach(val => {
                if (val.points_category == "") {
                    flag2 = true;
                }
                if (val.multiplier <= 0) {
                    flag = true;
                }
                if (!val.percentage) {
                    flag3 = true;
                }
                // if (val.manage_spend_limit) {
                //     if (val.manage_spend_limit_options.spend_limit == "") {
                //         flag4 = true;
                //     }
                //     if (val.manage_spend_limit_options.beginning_date == "") {
                //         flag5 = true;
                //     }
                //     if (val.manage_spend_limit_options.end_date == "") {
                //         flag6 = true;
                //     }
                // }
            })
        }
    })
    if (flag2) {
        this.errors[prop] = {
            msg: 'Target offer name is required',
            success: true
        }
    }
    else
        if (flag3) {
            this.errors[prop] = {
                msg: 'Target offer percentage is required',
                success: true
            }
        }
        else if (flag) {
            this.errors[prop] = {
                msg: 'Target offer multiplier should be greater than 0',
                success: true
            }
        }
        else if (flag4) {
            this.errors[prop] = {
                msg: 'Spend limit is required',
                success: true
            }
        }
        else if (flag5) {
            this.errors[prop] = {
                msg: 'Beginning Date is required',
                success: true
            }
        }
        else if (flag6) {
            this.errors[prop] = {
                msg: 'End Date is required',
                success: true
            }
        }
        else {
            this.errors[prop] = {
                msg: '',
                success: false
            }
        }
}


export {
    validateUpgradeCard, validateIssuerName, onSubmitIssuer, onLoginSubmit, validatePassword,
    validateEmail, validateCardName, validateProductChange, validateDowngradeCard, validateUploadPhoto,
    validateAnnualFee, validateFeeDescription, validatePointDescription, validateRuleEffectiveDate,
    validateReply, validateFirstName, validateLastName, validateConfirmPassword, onAddAdmin, onAccountSettings,
    validateAlphaNumeric, validateAlpha, validateNumeric, validateRules, validateFeeCategory, validatePoints, validatePointsNames,
    validateSubject, validateBody, validatePerks, validateBonus, validateLinkUrl, validateBonusType, validateExpirationDate, validateEmoji,
    validateTargetedStatus, validateBonusCategory, validatePromoCategory, validatePrimaryHashtag, validateHeadline, validateTargetedOffers, validateGroupPoints, validateDisclosure, validateRatesFees
}